import { DiffEditor } from '@monaco-editor/react'
import { Box } from '@mui/material'

import {
  CODE_FIELD_COMMON_OPTIONS,
  CodeFieldContainer,
  useResizable,
} from 'components/Form/CodeField'
import { Props } from './types'

export const DiffViewer = ({ modified, original }: Props): React.JSX.Element => {
  const { containerRef, editorHeight } = useResizable({})

  return (
    <CodeFieldContainer ref={containerRef}>
      <Box
        sx={{
          height: editorHeight,
          minWidth: 800,
        }}
      >
        <DiffEditor
          /*
          Props keepCurrentModifiedModel and keepCurrentOriginalModel
          in monaco >= 0.51 are required for the DiffEditor to function correctly
          They stop the wrapper from disposing the text models on unmount
          https://github.com/suren-atoyan/monaco-react/issues/647
          */
          keepCurrentModifiedModel
          keepCurrentOriginalModel
          modified={modified}
          options={{
            ...CODE_FIELD_COMMON_OPTIONS,
            hideUnchangedRegions: { enabled: true },
            lineNumbers: 'off',
            readOnly: true,
            renderOverviewRuler: false,
            renderSideBySide: true,
            useInlineViewWhenSpaceIsLimited: false,
          }}
          original={original}
        />
      </Box>
    </CodeFieldContainer>
  )
}
